import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { DATE_INTL_FORMAT_TWO_DIGITS } from 'src/comps/DateIntl/constants'

import Price from 'client/components/Price'
import DateIntl from 'src/comps/DateIntl'

import { CancellationMessageBase, Title, Message } from './styles'
import messages from './messages'

const CancellationMessage = ({ cancellationDate, cancellationAmount, currency, pendingAmount }) => {
  const Date = () => <DateIntl value={cancellationDate} format={DATE_INTL_FORMAT_TWO_DIGITS} />

  const PartialRefund = () => (
    <>
      <Title>
        <FormattedMessage {...messages.SFL} />
      </Title>
      <Message>
        <FormattedMessage
          {...messages.partialRefundDesc}
          values={{
            date: <Date />,
            amount: <Price amount={cancellationAmount} currency={currency} />,
          }}
        />
      </Message>
    </>
  )

  const FreeCancellation = () => (
    <>
      <Title>
        <FormattedMessage {...messages.NOR} />
      </Title>
      <Message>
        {pendingAmount === 0 ? (
          <FormattedMessage
            {...messages.cancelWithRefund}
            values={{ cancellation_date: <Date /> }}
          />
        ) : (
          <FormattedMessage {...messages.youWontPay} values={{ payment_date: <Date /> }} />
        )}
      </Message>
    </>
  )

  const NonRefundable = () => (
    <>
      <Title>
        <FormattedMessage {...messages.NRF} />
      </Title>
      <Message>
        <FormattedMessage {...messages.canNotBeCancelled} />
      </Message>
    </>
  )
  return (
    <CancellationMessageBase>
      {!cancellationDate && <NonRefundable />}
      {cancellationDate && cancellationAmount > 0 && <PartialRefund />}
      {cancellationDate && cancellationAmount === 0 && <FreeCancellation />}
    </CancellationMessageBase>
  )
}

CancellationMessage.propTypes = {
  cancellationDate: PropTypes.string,
  cancellationAmount: PropTypes.number,
  currency: PropTypes.string,
  pendingAmount: PropTypes.number,
}

export default CancellationMessage
